import { log } from './logger';

/**
 * Quanto si aspetta che il worker nuovo prenda il comando prima di ricaricare
 * comunque. Se qualcosa va storto nel passaggio di consegne, meglio una pagina
 * ricaricata sulla versione vecchia che un bottone che non fa niente.
 */
export const ATTESA_NUOVO_WORKER_MS = 3_000;

/**
 * Ricarica l'app, saltando sulla versione nuova se ce n'e' una in attesa.
 *
 * ⚠️ `window.location.reload()` da solo NON basta, ed e' controintuitivo: se il
 * service worker vecchio controlla ancora la pagina, il ricarico gli richiede le
 * stesse risorse precaricate e **rimette in piedi lo stesso identico bundle**.
 * Un bottone «Ricarica» scritto cosi' sembra fare la cosa giusta e non la fa.
 *
 * `registerType: 'prompt'` (vedi vite.config.ts) tiene apposta il worker nuovo in
 * attesa, e chi lo attiva — `useAppUpdate` — lo fa solo quando la scheda e'
 * sicura E l'utente e' fermo da 45 secondi o la scheda e' nascosta. Chi sta
 * fissando una schermata rotta e preme «Riprova» non e' fermo: quella
 * condizione non si avvera mai, e l'aggiornamento resta li' finche' l'app non
 * viene chiusa e riaperta a mano. Questa e' la stessa sequenza, ma su richiesta
 * esplicita: chi preme ha appena dichiarato che ricaricare gli sta bene.
 *
 * Senza service worker (browser che non lo supporta, sviluppo) si ricarica e
 * basta: la pagina non e' controllata da nessuno e prende comunque il nuovo.
 */
export async function ricaricaApp(): Promise<void> {
  const ricarica = (): void => {
    window.location.reload();
  };

  const sw = navigator.serviceWorker;
  if (!sw) {
    ricarica();
    return;
  }

  let registrazione: ServiceWorkerRegistration | undefined;
  try {
    registrazione = await sw.getRegistration();
    /* Chiedere se c'e' qualcosa di nuovo PRIMA di decidere: al risveglio la
       verifica periodica di `useAppUpdate` puo' non essere ancora passata. */
    await registrazione?.update();
  } catch (err) {
    log.warn('RicaricaApp', 'controllo del worker fallito, ricarico e basta', { errore: (err as Error)?.message });
    ricarica();
    return;
  }

  const inAttesa = registrazione?.waiting;
  if (!inAttesa) {
    ricarica();
    return;
  }

  log.info('RicaricaApp', 'c\'e\' una versione in attesa: la attivo e ci salto sopra');
  let fatto = false;
  const unaVoltaSola = (): void => {
    if (fatto) return;
    fatto = true;
    ricarica();
  };
  /* Il worker nuovo prende il comando in modo asincrono: ricaricare subito dopo
     `SKIP_WAITING` significherebbe farlo mentre al comando c'e' ancora il
     vecchio, cioe' ricadere sul bundle vecchio. */
  sw.addEventListener('controllerchange', unaVoltaSola, { once: true });
  window.setTimeout(unaVoltaSola, ATTESA_NUOVO_WORKER_MS);
  inAttesa.postMessage({ type: 'SKIP_WAITING' });
}
